import React from 'react'
import { useSelector } from 'react-redux'
import { Badge } from 'reactstrap'
import { RootState } from 'types'
import { getNestedObject } from '../../lib/util'

interface SearchCriteriaBadgeProps {
  clearSearch: () => void
  managerType: string
}

interface Criteria {
  [key: string]: string | number
}

const SearchCriteriaBadge: React.FC<SearchCriteriaBadgeProps> = ({
  clearSearch,
  managerType,
}) => {
  const criteria = useSelector((state: RootState) => {
    const manager = getNestedObject(state, managerType)
    return manager?.criteria || manager?.searchCriteria || {}
  })

  return (
    <div>
      <p>
        Search Criteria:&nbsp;
        {Object.keys(criteria).map(key => {
          return (
            <span className="criteria" key={key}>
              <Badge
                color="info"
                style={{ fontSize: 'inherit', marginRight: '0.5rem' }}
              >
                {key}:{' '}
                <span style={{ fontWeight: 'bold' }}>{criteria[key]}</span>
                <span
                  style={{ cursor: 'pointer', marginLeft: '0.25rem' }}
                  data-testid={`remove-clear-search-${key}`}
                  onClick={clearSearch}
                >
                  &times;
                </span>
              </Badge>
            </span>
          )
        })}
      </p>
    </div>
  )
}

export default SearchCriteriaBadge
